module.exports = "/_next/static/images/logo_for_shunwei-450e2f45fdcdc993ec3e9f6d9c8b6933.png";